
import { css } from 'lit';
export default css`
.header__search {
max-width: 640px
}

@media (min-width: 1024px) {

.header-wrapper--mlp {
    padding-bottom: 45px
}
  }

.header-wrapper__inner {
  padding: 0;
  max-width: 100%;
}`;